import React, { useState } from "react";
import { userApi } from "../../api/auctiongate.js";

const HOSTS = [
  { value: "copart.com", label: "copart.com" },
  { value: "iaai.com", label: "iaai.com" },
  { value: "copart.ca", label: "copart.ca" },
  { value: "ca.iaai.com", label: "ca.iaai.com" },
];

export default function UserEvents() {
  const [host, setHost] = useState("copart.com");
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    setErr(null);
    try {
      setData(await userApi.events(host));
    } catch (e) {
      if (e?.status && e.status >= 400 && e.status < 500) setData([]);
      else setErr(e?.message || "Failed");
    } finally {
      setLoading(false);
    }
  };

  const items = Array.isArray(data) ? data : Array.isArray(data?.data) ? data.data : [];

  return (
    <div className="card">
      <div className="card__title">
        User Events
        <span className="badge">bid / page / auth log</span>
      </div>
      <div className="row" style={{ marginBottom: 10 }}>
        <select value={host} onChange={(e) => setHost(e.target.value)} style={{ padding: 8, border: "1px solid var(--color-border-input)", borderRadius: 8 }}>
          {HOSTS.map((h) => (
            <option key={h.value} value={h.value}>
              {h.label}
            </option>
          ))}
        </select>
        <button className="btn btn-primary" onClick={load} disabled={loading}>
          {loading ? <span className="loader" /> : "Fetch"}
        </button>
      </div>
      {err && <div className="login-error">{err}</div>}
      {!err && items.length === 0 && data !== null && (
        <div className="placeholder-panel">No events yet. Sign in + visit an auction page first.</div>
      )}
      {items.length > 0 && (
        <div className="small" style={{ maxHeight: 220, overflow: "auto" }}>
          {items.slice(0, 25).map((ev, i) => (
            <div key={ev.id ?? i} style={rowStyle}>
              <span style={{ fontFamily: "monospace" }}>{ev.event || ev.action || "event"}</span>
              <span className="muted">{ev.host || ""}</span>
              <span>{ev.lot_number || ev.vin || ""}</span>
              <span className="muted small">{ev.created_at || ev.date || ""}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const rowStyle = {
  display: "grid",
  gridTemplateColumns: "1.2fr 1fr 1fr 1fr",
  gap: 8,
  padding: "6px 8px",
  borderBottom: "1px solid var(--color-border)",
};
